import { useState, useRef, useEffect } from 'react';
import { useRouter } from 'next/router';
import throttle from 'lodash/throttle';
import RegisterBox from '../RegisterBox';
import styles from './index.module.scss';
import TabB from './TabB';
import Programme from './TabB/Programme';
import ScrollCard from './TabB/ScrollCard';
import EarnMore from './TabB/EarnMore';
import UseSpecials from './TabB/UseSpecials';
import { useLang } from '@/i18n';

export default function PageTabs() {
    const { t } = useLang('ecocreditsday');
    const { locale } = useRouter();
    const tabNum = { jp: 1, kr: 1, za: 3, au: 3 };
    const tabs = [];
    const [activeTab, setActiveTab] = useState('0');
    const tabRef = useRef<HTMLDivElement | null>(null);
    const menuRef = useRef<HTMLDivElement | null>(null);
    const len = tabNum[locale as keyof typeof locale] || tabNum.za;
    const refArr: any[] = [];
    let isClickTab = false;

    for (let i = 0; i < len; i++) {
        tabs.push({ key: `${i}`, name: t(`pageTabs.tab${i + 2}`) });
    }
    for (let i = 0; i < len; i++) {
        refArr.push(useRef(null));
    }

    const clickTab = (key: string) => {
        isClickTab = true;
        if (key !== activeTab) {
            setActiveTab(key);
            if (['jp', 'kr'].includes(locale as string)) {
                const top = tabRef.current?.offsetTop;
                if (top) {
                    window?.scrollTo({ top: top + 60 });
                }
            } else {
                refArr[key as keyof typeof refArr]?.current?.scrollIntoView();
            }
        }
    };

    const changeTabLine = throttle(() => {
        const dom: any = menuRef.current;
        const { top }: any = dom?.getBoundingClientRect();
        dom.style.display = !!top ? 'inline-flex' : 'flex';
        if (!['jp', 'kr'].includes(locale as string) && !isClickTab) {
            for (let i = 0; i < refArr.length; i++) {
                const position: Record<string, string | number> = refArr[i].current?.getBoundingClientRect();
                if (position.top <= 0 && position.bottom >= 1) {
                    setActiveTab(`${i}`);
                }
            }
        }
        isClickTab = false;
    }, 1000 / 60);

    useEffect(() => {
        window.addEventListener('scroll', changeTabLine);
        return () => {
            window.removeEventListener('scroll', changeTabLine);
        };
    }, []);

    return (
        <div className={styles.pageTabs}>
            <div className="tabs-box" ref={tabRef}>
                <div className="menu-box">
                    <div className="tabs-menu" ref={menuRef}>
                        {tabs.map((item: Record<string, string>) => (
                            <div key={item.key} className={`tab-item ${item.key === activeTab ? 'active-tab' : ''}`} onClick={() => clickTab(item.key)}>
                                {item.name}
                            </div>
                        ))}
                    </div>
                </div>
                <div className="content-box">
                    <div className="tab-content">
                        {['kr'].includes(locale as string) && (
                            <>
                                <TabB />
                            </>
                        )}
                        {['jp'].includes(locale as string) && (
                            <>
                                <TabB />
                                {/*{activeTab === '0' && <TabC />}*/}
                            </>
                        )}
                        {!['jp', 'kr', 'au'].includes(locale as string) && (
                            <>
                                {/*<div ref={refArr[0]}>
                                    <GiftBox />
                                    <Lottery />
                                </div>*/}
                                <div ref={refArr[0]}>
                                    <Programme />
                                    <ScrollCard />
                                </div>
                                <div ref={refArr[1]}>
                                    <EarnMore />
                                </div>
                                <div ref={refArr[2]}>
                                    <UseSpecials />
                                </div>
                                <RegisterBox />
                            </>
                        )}
                        {['au'].includes(locale as string) && (
                            <>
                                <div ref={refArr[0]}>
                                    <Programme />
                                    <ScrollCard />
                                </div>
                                <div ref={refArr[1]}>
                                    <EarnMore />
                                </div>
                                <div ref={refArr[2]}>
                                    <UseSpecials />
                                </div>
                                <RegisterBox />
                            </>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}
